<mat-card class="stepper">

  <div class="allStepWithBack">
    <button mat-flat-button color="primary" (click)="SubmitBackButton()" matTooltip="Back">
      Back
    </button>

    <div class="allSteps">
      <div [ngClass]="stepCompleted >0 ? 'active step done' : 'active step'">
  
        <div class="stepStatus" [routerLink]="'/esignature/first'">
          <span class="nmbr">1</span>
          <span class="stepName">Upload Document</span>
          <span class="stepIcon">
            <mat-icon>picture_as_pdf</mat-icon>
          </span>
        </div>
      </div>
    
      <div [ngClass]="stepCompleted >1 ? 'active step done' : 'active step'">
    
        <div class="stepStatus">
          <span class="nmbr">2</span>
          <span class="stepName">Add Participant </span>
          <span class="stepIcon">
            <mat-icon>account_box</mat-icon>
          </span>
        </div>
    
    
    
      </div>
    
    
      <div [ngClass]="stepCompleted >2 ? 'active step done' : 'step'">
    
        <div class="stepStatus" (click)="showFormEditor()">
          <span class="nmbr">3</span>
          <span class="stepName">Design Form </span>
          <span class="stepIcon">
            <mat-icon>design_services</mat-icon>
          </span>
        </div>
      </div>
    
      <div [ngClass]="stepCompleted >3 ? 'active step done' : 'step'">
        <div class="stepStatus" (click)="showFormFinish()">
          <span class="nmbr">4</span>
          <span class="stepName">Review & Send </span> <span class="stepIcon">
            <mat-icon>send</mat-icon>
          </span>
        </div>
      </div>
    </div>

    <button mat-flat-button color="primary" matTooltip="Next" [disabled]="!SubmitNextButtonDisabled" (click)="SubmitNextButton()">
      Next
    </button>   
  </div>

</mat-card>

<ng-template #AddMessage>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>gesture</mat-icon>
    </span>
    <ng-container>
      Enter Message
    </ng-container>
    <button mat-icon-button (click)="closeMessagePopUp()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content class="mat-typography">
    <ng-container>
      <ckeditor [config]="editorConfig"
      [(ngModel)]="participantMessageInfo"
      editorUrl="https://cdn.ckeditor.com/4.14.0/full/ckeditor.js" 
      ></ckeditor>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button (click)="saveMessage()" color="primary">Save</button>
  </mat-dialog-actions>
</ng-template>

<div class="formWrapper">
  <mat-card class="container">
    <div class="page_header">
      <p>
        <span>Select & Add Participants</span>
        <span class="labl">Signers will be asked to sign as per group order</span>
      </p>
      <div class="messageGroup">
        <button mat-stroked-button class="mr-5" color="primary" (click)="addMessage()" matTooltip="Add Message">
          <mat-icon>add</mat-icon> Add Message
        </button>
        <button mat-stroked-button color="primary" (click)="addProjectGroup()" matTooltip="Add Group">
          <mat-icon>add</mat-icon> Add Group
        </button>

      </div>
    </div>


    <div class="step two" id="step2">
      <div class="esign">
        <div class="panel" cdkDropListGroup>
          <div class="groupHolder" *ngFor="let g of projectGroups">

            <div cdkDropList id="{{g.groupName}}" [cdkDropListData]="g.projGrpRelationParticipantList"
              class="example-list" (cdkDropListDropped)="drop($event,g.groupID)">

              <div class="groupheading">
                <h2 *ngIf="g.groupType ==1" (click)="renameGroup(renamegroupNameDialog, g)">
                  <mat-icon>create</mat-icon>{{g.groupName}}
                </h2>

                <h2 *ngIf="g.groupType !=1">
                  <mat-icon>description</mat-icon>{{g.groupName}}
                </h2>

                <button *ngIf="g.groupType ==1" class="delGroup"  matTooltip="Delete Group" mat-icon-button (click)="DeleteGroup(g)">
                  <mat-icon>delete_outline</mat-icon>
                </button>

                <button mat-stroked-button color="primary" (click)="addRelationsNew(g)" matTooltip="Add Participant">
                  <mat-icon>add</mat-icon> Add Participant
                </button>

                <!-- <button color="PlusRole" color="accent" mat-icon-button (click)="addRelationsNew(g)">
                  <mat-icon matTooltip="Add Participant">add</mat-icon>
                </button> -->

                <!-- <button mat-button class="PlusRole" color="accent" (click)="addRelation(relation,g)" matTooltip="Add Participant">
                  Add Participant
                </button> -->

              </div>

              <div *ngIf="g.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
                <p class="nocontent">No participant added</p>
              </div>

              <div *ngFor="let p of g.projGrpRelationParticipantList" class="moveblock example-box" cdkDrag>

                <div class="DragIcon" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </div>

                <div class="Colrd" (click)="updateRelationColor(renameRelationColorDialog, p)"
                  [ngStyle]="{'background-color': p.colourCode }">
                  <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                </div>


                <div class="userInfo">
                  <div class="chipss">
                    
                      <button mat-flat-button matTooltip="Edit" class="setParticipant" (click)="updateRelationName(updateRelationNameDialog, p,g)"> {{p.relationName}} 
                        <mat-icon>edit</mat-icon>
                      </button>
                 
                  </div>
                  
                  <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                    <div class="userpic" *ngIf="p.participantImageURL">
                      <img [src]="p.participantImageURL" alt="" />
                    </div>

                    <div class="userpic" *ngIf="!p.participantImageURL">
                      <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                      <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
                      <span class="shortName" *ngIf="p.contactEmail">{{getShortName(p.contactEmail)}}</span>
                    </div>

                    <div class="info">
                      <p *ngIf="p.participantName">{{ p.participantName }} </p>
                     
                      <p *ngIf="p.roleName">{{ p.roleName }} </p>
                      <p *ngIf="p.typeOfParticipant==0">{{p.contactEmail}}</p>
                      <p class="emailID" *ngIf="p.typeOfParticipant!=0">{{ p.participantEmail }} </p>
                    </div>

                    <!-- <div class="email">
                    <p *ngIf="p.participantEmail">{{ p.participantEmail }} </p>
                    </div> -->
                    <!-- <p *ngIf="p.participantName">{{ p.participantEmail }} </p> -->
                    <button class="removeContact" matTooltip="Remove" mat-icon-button color="basic" (click)="RemoveRelation(p)">
                      <mat-icon>close</mat-icon>
                    </button>
                    </div>
                  <ng-container *ngIf="!p.participantName && !p.roleName &&  !p.contactEmail">
                    <div class="addPartcipant"  (click)="assignUserNew(true,false,'',p)">
                      <button *ngIf="showAddContactButton"  mat-icon-button color="primary" class="personadd">                   
                      <mat-icon>person_add</mat-icon>
                    </button>
                    <span class="parti" >Add Participant</span>
                    </div>
                    <!-- <div class="addPartcipant"  (click)="assignUser(addAssigne,true,false,'',p)">
                      <button *ngIf="showAddContactButton"  mat-icon-button color="primary" class="personadd"
                     >                   
                      <mat-icon>person_add</mat-icon>
                    </button>
                    <span class="parti" >Add Participant</span>
                    </div> -->
                  </ng-container>
                  
                  <!-- <mat-icon matTooltip="Approver" >check_circle_outline</mat-icon> -->
                  
                </div>
                <div class="Cancel">
                  <span class="approver" *ngIf="p.isApprover==true">Approver</span>
                  <button mat-icon-button (click)="RemoveGroupRelation(p)" matTooltip="Delete Group Participant">
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stepaction">
      <div class="sender">
        <mat-icon>send</mat-icon>
        <div class="name">
          <label>SENDER</label>
          <span>{{this.currentUser.Name}}</span>
        </div>
      </div>
    </div>
  </mat-card>
</div>

<ng-template #renamegroupNameDialog>
  <h2 matDialogTitle>Rename Group</h2>
  <mat-dialog-content>
    <form [formGroup]="updateGroupNameForm" class="example-form">
      <mat-form-field class="example-full-width">
        <mat-label>Group Name</mat-label>
        <input  matInput placeholder="Group Name" formControlName="groupName"  />
      
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()"> Cancel </button>
    <button mat-button color="primary" [disabled]="!updateGroupNameForm.valid"
      (click)="UpdateGroupName(updateGroupNameForm.value)">
      Update
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #relation>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Participant to {{groupName}}
    
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content class="mat-typography">

    Note: Participant Type are placeholders for the types of people who will sign.  <b>They are NOT for Contacts or Emails</b>.  (Ex of Participant Type:  Signer, Attorney, Doctor, Administrator)

    <app-contactlist [objectList]="transRoleList" [isRolePopup]="isRolePopup"
      (NotifyItemSelected)="RoleSelected($event)" (NotifyListfetch)="getTransactinalRoles($event)">
    </app-contactlist>
   
    <ul class="selectedlist">
    <form [formGroup]="dynamicForm">
      <div formArrayName="filters">
       <li *ngFor="let role of filtersFormArray.controls; let i = index;">
    
          <ng-container [formGroupName]="i">    
            <div class="userndetail">
              <div class="Colrd" [ngStyle]="{'background-color': role.controls.colourCode.value }">
              </div>
              <div class="detail">               
                <h4> {{role.controls.transactionalRoleName.value}}</h4>
              </div>

              <div class="chooseColor">
                <mat-form-field>                 
                <mat-select  (selectionChange)="onChangeColourCode($event,role.controls.transactionalRoleName.value)"
                  placeholder="Select Color" formControlName="colourCode">
                  <mat-option *ngFor="let code of colourCode" [ngStyle]="{'background-color': code.colourCode}"
                    [value]="code.colourCode">
                    {{ code.colourCode }}
                  </mat-option>
                </mat-select>
              </mat-form-field> 
              </div>
              <div class="opt">
                <button mat-icon-button>
                  <mat-icon (click)="removeItem(role,isRolePopup)">cancel</mat-icon>
                </button>
              </div>
            </div> 
          </ng-container>
          
         <li> 
      </div>
    </form>
  </ul>
  </mat-dialog-content>


  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showContactRoleAddButton (click)="AddRelations()">
      Done 
    </button>
  </mat-dialog-actions>
</ng-template>


<ng-template #addAssigne>

  <h2 mat-dialog-title *ngIf="isShare">
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Select & Add Participant
    <button mat-icon-button (click)="close()">

      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <h2 mat-dialog-title *ngIf="!isShare">
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Contact
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="radOpts" *ngIf="isShare">

      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1" [checked]=true (click)="selectSharedAccessRb(1)">{{contactNames}}</mat-radio-button>
        <mat-radio-button value="2" (click)="selectSharedAccessRb(2)">Role</mat-radio-button>
        <mat-radio-button *ngIf="coreNames!=''" value="3" (click)="selectSharedAccessRb(3)">{{coreNames}}</mat-radio-button>
        <mat-radio-button value="4" (click)="selectSharedAccessRb(4)">User</mat-radio-button>
      </mat-radio-group>

    </div>

    <ng-container *ngIf="showContact==true && peoples.length==0">
      <app-contactlist *ngIf="!isSharedAccessRolePopup" [objectList]="contactsList" 
        [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" 
        (NotifyItemSelected)="contactSelected($event)" (NotifyListfetch)="getContactListCoreImplementation($event)"
        (keydown.enter)="onEnter($event)">
      </app-contactlist>
    </ng-container>
  
    <ng-container *ngIf="showRole==true && selectedsharedAccessRole.length==0">
      <app-contactlist *ngIf="isSharedAccessRolePopup" [objectList]="sharedAccessRoleList"
        [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" 
        (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)"
        (click)="onclickRole($event)">
      </app-contactlist>
    </ng-container>

    <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>

    <ng-container *ngIf="showSearchCore==true && selectCoreList.length==0">
      <mat-form-field  appearance="fill">
        <input matInput placeholder="Search {{coreNames}}" [formControl]="stateCtrl"
          (input)="searchCore($event.target.value)" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option  (click)="coreSelected(core)" 
             *ngFor="let core of attachedToCoreList" [value]="core.name">
              <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                  <div class="userpic">
                      <img *ngIf="core.imageUrl!=''" src="{{core.imageUrl}}" alt="">
                      <span class="username" *ngIf="core.imageUrl==''" class="username">
                          {{core.shortName}}
                        </span>
                  </div>
                  <div class="info">
                    <p> {{ core.name }}</p>
                    <p class="email">{{ core.email }}</p>
                  </div> 
              </span>
            </mat-option>
          </mat-autocomplete>
      </mat-form-field>
    </ng-container>

   

    <ul *ngIf="!isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
              {{user.shortName}}
            </span>
          </div>
          <div class="detail">
            <h4>{{user.name}}</h4>
            <p>{{user.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeItem(user,isRolePopup)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
          <div class="detail">
            <h4> {{role.name}}</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeItemRoleParticipant(role,isSharedAccessRolePopup)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="selectCoreList.length>0" class="selectedlist">
      <li *ngFor="let user of selectCoreList">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
              {{user.shortName}}
            </span>
          </div>
          <div class="detail">
            <h4>{{user.name}}</h4>
            <p>{{user.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon (click)="removeCore(user)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <ul *ngIf="userSelectedList.length>0" class="selectedlist">
      <li *ngFor="let user of userSelectedList">
        <div class="userndetail">
            <!-- <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div> -->
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateParticipants()">Done</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #renameRelationColorDialog>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Relation Name {{transactionalRoleName}}
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content>
    <form [formGroup]="updateRelationColorForm" class="example-form">

      <div class="slec">
        <div class="Colrd" [ngStyle]="{'background-color': selectedcolorOnUpdate }"></div>
      <mat-form-field>
        <mat-label>Select color</mat-label>
        <mat-select formControlName="colourCode" (selectionChange)="onChangeColourCodeupdate($event)">
          <mat-option *ngFor="let color of colourCode" [ngStyle]="{'background-color': color.colourCode}"
            [value]="color.colourCode">
            {{color.colourCode}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      </div>

    </form>
    
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()"> Cancel </button>
    <button mat-button color="primary" [disabled]="!UpdateRelationColorButton"
      (click)="UpdateRelationColor(updateRelationColorForm.value)">
      Save
    </button>
  </mat-dialog-actions>
</ng-template>


<ng-template #updateRelationNameDialog>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
     Update Relations for {{relationName}}
    
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content class="mat-typography">

    Note: Relationships are placeholders for the types of people who will sign.  <b>They are NOT for Contacts or Emails</b>.  (Ex of Relationships:  Signer, Attorney, Doctor, Administrator)

    <mat-form-field appearance="fill">
      <input matInput
              #stateInput (keyup)="0"
              placeholder="Add type of relationship"
              aria-label="State"
              [matAutocomplete]="auto" 
              (input)="getTransactinalRoles($event.target.value)"
              [formControl]="stateCtrl"
              id="stateCtrlid">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option (onSelectionChange)="RelationNameSelected(obj)" 
         *ngFor="let obj of transRoleList" [value]="obj.transactionalRoleName">
          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="info">
                <p> {{ obj.transactionalRoleName }}</p>
              </div>
          </span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
   
    <ul class="selectedlist">   
      <div>
       <li *ngFor="let rel of RelationNameList">
          <ng-container>    
            <div class="userndetail">            
              <div class="detail">               
                <h4> {{rel.transactionalRoleName}}</h4>
              </div>           
              <div class="opt">
                <button mat-icon-button>
                  <mat-icon (click)="removeRelationName(rel)">cancel</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </li> 
       </div>
    </ul>
   <div class="approverHolder">

    <mat-form-field>
      <mat-label>Type of Participant</mat-label>
      <mat-select (selectionChange)="onSelectParticpant($event)" [(ngModel)]="typeOfParticipant">
        <mat-select-trigger>
          {{ textNameShow }}
        </mat-select-trigger>
    
        <ng-container *ngFor="let participant of typeofParticipantList">
          <mat-option [value]="participant.value">
            <mat-icon *ngIf="participant.icon">{{ participant.icon }}</mat-icon>
            {{ participant.name }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    
    <mat-slide-toggle [(ngModel)]="selectedApprover" (change)="makeApprover($event,selectedParticipant,selectedGroup)">Approver</mat-slide-toggle>

   </div>
  
  
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!UpdateRelationButton (click)="UpdateRelations()">
      Update
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>  
  </mat-dialog-actions>
</ng-template>



<app-addnew *ngIf="showAddContact" (closeAdd)="getClose($event)" [name]="searchName" 
(sendContactId)=saveAddNewContact($event) [isShared]="isShare"
 [mainModuleName]='mainModuleName' [modulename]='Module' [ngClass]="{'open': showAddContact}" >
</app-addnew>
<style>
  .cke_notifications_area { display: none;}
</style>

<style>
  .cke_notification { display: none; }
</style>
<style>
  .cke_notification_warning { display: none; }
</style>